
import { db } from '../../lib/firebase';
import { collection, getDocs, writeBatch, doc, serverTimestamp } from 'firebase/firestore';

const stakingProducts = [
    {
        name: 'ETH 2.0 고정 스테이킹',
        asset: 'ETH',
        apy: 4.5,
        minAmount: 0.1,
        duration: 90,
        status: 'Active',
        totalStaked: 0,
        participantCount: 0,
        description: '이더리움 2.0 네트워크 보안에 기여하고 안정적인 보상을 받는 90일 고정 플랜입니다.'
    },
    {
        name: 'USDT 자유 적립식 스테이킹',
        asset: 'USDT',
        apy: 8.0,
        minAmount: 10,
        duration: 0,
        status: 'Active',
        totalStaked: 0,
        participantCount: 0,
        description: '테더(USDT)를 예치하고 연 8%의 수익을 받으세요. 언제든 자유롭게 해지가 가능합니다.'
    },
    {
        name: 'SOL 고수익 스테이킹',
        asset: 'SOL',
        apy: 12.0,
        minAmount: 5,
        duration: 30,
        status: 'Active',
        totalStaked: 0,
        participantCount: 0,
        description: '솔라나 고수익 플랜입니다. 30일간 예치하여 업계 최고 수준의 이율을 경험하세요.'
    }
];

export const seedStakingProducts = async () => {
    try {
        const querySnapshot = await getDocs(collection(db, 'staking_products'));
        const batch = writeBatch(db);

        // Delete existing products if any (optional, but good for clean seeding)
        querySnapshot.docs.forEach((d) => {
            batch.delete(d.ref);
        });

        stakingProducts.forEach((product) => {
            const newDocRef = doc(collection(db, 'staking_products'));
            batch.set(newDocRef, {
                ...product,
                createdAt: serverTimestamp(),
                updatedAt: serverTimestamp()
            });
        });

        await batch.commit();
        console.log('Staking products seeded successfully!');
    } catch (error) {
        console.error('Error seeding staking products:', error);
    }
};
